import { atom } from 'recoil';

//暫存已選擇類別(店家)
const storeCategory = atom<string>({ key: 'storeCategory', default: '' });

export default storeCategory;
